function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  points: "5.1,44.8 5.1,35.4 0.4,35.4 0.4,7.6 35.8,7.6 35.8,18.5 32.8,18.5 32.8,10.6 3.4,10.6 3.4,32.4 8.1,32.4  8.1,39.1 17.6,32.4 22.3,32.4 22.3,35.4 18.6,35.4  "
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M55.1,58.4L41.7,49H24.4V21.1h35.5V49h-4.8V58.4z M27.4,46h15.2l9.5,6.6V46h4.8V24.1H27.4V46z"
})))));

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M50.2,40.5h-16v-11h16V40.5z M37.1,37.5h10v-5h-10V37.5z"
}))));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M27.4,27.7H10.5V16.2h16.9V27.7z M13.5,24.7h10.9v-5.5H13.5V24.7z"
}))));

var SvgChatBubbles = function SvgChatBubbles(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/chat-bubbles.5078ce96.svg";
export { SvgChatBubbles as ReactComponent };